import { ValidationErrors, AbstractControl, FormControl } from '@angular/forms';
import { RootState } from '@next/core-lib/app';
import { Store, select } from '@ngrx/store';
import { of, timer, Observable } from 'rxjs';
import { map, switchMap, withLatestFrom, take } from 'rxjs/operators';

import { Barn } from '../models/cycle.model';
import { getChicksRemaining } from '../store/selectors/departure.selectors';

export const departureAmountValidator =
  (store: Store<RootState>, barn: FormControl) =>
  (input: AbstractControl): Observable<ValidationErrors | null> =>
    timer(1).pipe(
      withLatestFrom(
        store.pipe(
          select(getChicksRemaining),
          map((f) => (barn.value ? f((barn.value as Barn).id) : 0)),
        ),
      ),
      switchMap(([_, remainingChicks]: [unknown, number]) =>
        remainingChicks - parseInt(<string>input.value, 10) >= 0
          ? of(null)
          : of(<ValidationErrors>{ maxAmount: remainingChicks <= 0 ? true : remainingChicks }),
      ),
      take(1),
    );
